import React from "react";
import { ChevronDown } from "lucide-react";

const Accordion = ({ id, title, open, onToggle, children }) => (
  <div className="mb-4 overflow-hidden rounded-xl border-2 border-gray-200 bg-white shadow-sm transition-all duration-200 dark:border-gray-700 dark:bg-gray-800">
    <button
      onClick={() => onToggle(id)}
      className="dark:to-gray-750 dark:hover:from-gray-750 flex w-full items-center justify-between bg-gradient-to-r from-gray-50 to-gray-100 px-4 py-3 text-sm font-bold text-gray-800 transition-colors hover:from-gray-100 hover:to-gray-200 dark:from-gray-800 dark:text-gray-100 dark:hover:to-gray-700"
    >
      <span className="tracking-wide">{title}</span>
      <div
        className={`transform transition-transform duration-200 ${open ? "rotate-180" : ""}`}
      >
        <ChevronDown className="h-4 w-4 text-green-600 dark:text-green-400" />
      </div>
    </button>
    {open && (
      <div className="animate-slideDown px-4 py-4">
        <div className="space-y-3">{children}</div>
      </div>
    )}
  </div>
);

export default React.memo(Accordion);
